export default "__VITE_ASSET__b501205d__"